import { useParallax } from 'react-scroll-parallax';
import "./About.css"
const Parallax = (props) => {

    const { ref } = useParallax({ speed: -20,
                                scale:[1.5, .8]} );

  
     
    return( <div className='parallax-icon-div'>
      
        <img ref={ref} src={props.icon} className="icon-svg"/>
       
    </div>  ) 
    

  };

  export default Parallax